import React, { Component } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Grid } from "semantic-ui-react";
import PriceDisplay from "../../containers/PriceDisplay";
import { Header } from "../../components/common";
import styles from "./styles.less";

class ClubBanner extends Component {
  state = { finishedRendering: false };

  componentDidMount() {
    //setInterval(() => {
    this.setState({ finishedRendering: true });
    //}, 0);
  }

  render() {
    const {
      totalToSave,
      discountClubConfig,
      titles,
      orderCurrency,
      isRtl,
      showSimpleClubLoginModal,
      domainUrl,
      isMobileView
    } = this.props;
    const { finishedRendering } = this.state;
    const clubTitle = `${titles.Get} ${discountClubConfig &&
      discountClubConfig.Percentage}% ${titles.Discount}`;
    const checkImgUrlBase = domainUrl.substring(
      0,
      domainUrl.indexOf("actionUrl")
    );
    const checkImageUrl =
      checkImgUrlBase + "Content/HotelContent/images/check.png";

    return (
      <div
        className={cx(styles.clubWrapper, {
          [styles.appeared]: finishedRendering,
          [styles.mobileView]: isMobileView
        })}
      >
        <div className={styles.addonsHeader}>
          <Grid.Row>
            <Grid.Column className={styles.clubHeader} width={16}>
              <Header
                isRtl={isRtl}
                text={titles.JoinClub}
                textBold={titles.Free}
                isMobileView={isMobileView}
                noSidePadding={true}
                noPadding={false}
              />
              <div className={styles.clubHeaderSubTitle}>
                {titles.AlreadyMember}
                <span
                  className={styles.clubHeaderLogin}
                  onClick={showSimpleClubLoginModal}
                  onKeyDown={showSimpleClubLoginModal}
                  role="button"
                  tabIndex="0"
                >
                  {titles.Login}
                </span>
              </div>
            </Grid.Column>
          </Grid.Row>
        </div>
        <div
          className={cx(styles.clubBannerWrapper, {
            [styles.mobileView]: isMobileView
          })}
        >
          <div className={styles.clubBanner}>
            <div className={styles.clubBannerTextWrapper}>
              <div className={styles.clubBannerTitle}>{clubTitle}</div>
              <div className={styles.clubBannerSubTitle}>
                {titles.JoinAndSave}
                <span className={styles.clubBannerSave}>
                  <PriceDisplay
                    price={totalToSave}
                    currentCurrencyCode={orderCurrency.currencyCode}
                    fallBackCurrencySymbol={orderCurrency.currencySymbol}
                  >
                    {convertedPrice => convertedPrice}
                  </PriceDisplay>
                </span>
                {titles.InThisOrder}
                <img className={styles.checkImage} src={checkImageUrl} alt="" />
              </div>
            </div>
            <div
              className={styles.clubBannerButton}
              onClick={showSimpleClubLoginModal}
              onKeyDown={showSimpleClubLoginModal}
              role="button"
              tabIndex="0"
            >
              {titles.Join}!
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ClubBanner.propTypes = {
  totalToSave: PropTypes.number,
  discountClubConfig: PropTypes.object,
  titles: PropTypes.object,
  orderCurrency: PropTypes.object,
  showSimpleClubLoginModal: PropTypes.func,
  isMobileView: PropTypes.bool,
  isRtl: PropTypes.bool,
  domainUrl: PropTypes.string
};

export default ClubBanner;



// WEBPACK FOOTER //
// ./src/components/ClubBanner/ClubBanner.js